import React, { FC } from 'react';
import { useTranslations } from '@lang';
import { InfoBox, ErrorBox } from '@common/components';
import { CheckIcon, ErrorIcon } from './styles';

type BasketNotificationsProps = {
  activePromo?: { name: string } | null;
  promoCodeFailure: boolean;
};

export const BasketNotifications: FC<BasketNotificationsProps> = ({
  activePromo,
  promoCodeFailure,
}) => {
  const { t } = useTranslations();

  return (
    <>
      {activePromo?.name ? (
        <InfoBox>
          <CheckIcon width={20} height={20} />
          {t('basket.promoAdded')} {activePromo.name}
        </InfoBox>
      ) : null}
      {promoCodeFailure ? (
        <ErrorBox
          error={
            <>
              <ErrorIcon width={20} height={20} />
              {t('basket.codeError')}
            </>
          }
        />
      ) : null}
    </>
  );
};
